import api from "../api";
export default {
  getSchools({ country }) {
    return api.get(`schoolnew?country=${country}`);
  },
  getSchoolClasses({ schoolId }) {
    return api.get("classnew", { params: { school: schoolId, has_dfm: 1 } });
  },
};
